import connectTrendingItems from "instantsearch.js/es/connectors/trending-items/connectTrendingItems.js";
import { useConnector } from "../hooks/useConnector.js";
export function useTrendingItems(props, additionalWidgetProperties) {
  return useConnector(connectTrendingItems, props, additionalWidgetProperties);
}